// @ts-ignore
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const QuestionnaireQuestionTextFragmentDoc = gql`
    fragment questionnaireQuestionText on QuestionnaireQuestionText {
  __typename
  id
  title
  required
  textarea
}
    `;